import http from '../utils/http';

function form(data) {
  return http.post('contact', data);
}

export default form;
